import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import { map, Observable, tap } from 'rxjs';
import { DatesAndAccupancyComponent } from '../datesAndAccupancy/datesAndAccupancy.component';
import { selectBestPrice, selectBestPriceMealPLan, selectBookingLink, selectClientCountry, selectDatesAndAccupancy, selectDatesAndAccupancyResult, selectEngineOptions, selectHotelBookingData, selectHotelBookingLoader, selectHotelBookingNoAvailability, selectIsMobile, selectMainImage, selectProposition, selectPropositionLoader, selectRoomNameTranslation, selectSearchPanelVisibility, selectWHasBook } from 'app/widget/state/selectors';
import { TranslateModule } from '@ngx-translate/core';
import { OtaPricesComponent } from "../otaPrices/otaPrices.component";
import { DatesAndAccupancy, HotelBookingDataDetails, Proposition } from 'app/widget/state/index.types';
import { CurrencyExchangePipe, CustomTranslatePipe, RemoveWhitespacePipe, RoundPipe } from 'app/widget/index.pipes';
import moment from 'moment';
import { DatesAndAccupancySubmitted, Minimize, MobileSearchVisibility, SearchPanelVisibility } from 'app/widget/state';
import { TuiDay, TuiDayRange } from '@taiga-ui/cdk';
import { Actions } from '@ngrx/effects';
import { CanAccommodateOccupancy } from 'app/helpers';
import { OccupancyInfoComponent } from '../occupancyInfo/occupancyInfo.component';
import { BookingPolicyService } from 'app/widget/services/bookingPolicy.service';
import { RouterOutlet } from '@angular/router';
import { Annulation } from 'app/widget/bookingPolicy.type';

@Component({
  selector: 'app-search-dispo',
  standalone: true,
  imports: [
    CommonModule,
    ...TAIGA_UI_MODULES,
    FormsModule,
    DatesAndAccupancyComponent,
    OccupancyInfoComponent,
    TranslateModule,
    CustomTranslatePipe,
    CurrencyExchangePipe,
    RemoveWhitespacePipe,
    RouterOutlet
],
  templateUrl: './searchDispo.component.html',
  styleUrl: './searchDispo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchDispoComponent{

  bookingButton = input(false, {alias: 'bookingButton', transform: (v: unknown) => Boolean(v)})

  moment = moment

  store$ = inject(Store);
  action$ = inject(Actions)
  bookingPolicy = inject(BookingPolicyService);
  selectDatesAndAccupancyResult$                               = this.store$.select(selectDatesAndAccupancyResult)
  selectHotelBookingData$                                      = this.store$.select(selectHotelBookingData)
  selectHotelBookingLoader$: Observable<boolean>               = this.store$.select(selectHotelBookingLoader)
  selectBestPrice$: Observable<HotelBookingDataDetails | null> = this.store$.select(selectBestPrice)
  selectBestPriceMealPLan$ = this.store$.select(selectBestPriceMealPLan)
  onFailed$                = this.store$.select(selectHotelBookingNoAvailability)
  selectDatesAndAccupancy$ = this.store$.select(selectDatesAndAccupancy)

  selectPropositionLoader$ = this.store$.select(selectPropositionLoader)
  selectProposition$         = this.store$.select(selectProposition)

  selectWHasBook$: Observable<boolean>     = this.store$.select(selectWHasBook);
  selectBookingLink$: Observable<string[]> = this.store$.select(selectBookingLink);
  selectClientCountry$: Observable<string|undefined>     = this.store$.select(selectClientCountry);

  SearchPanelVisibility$ = this.store$.select(selectSearchPanelVisibility)
  selectIsMobile$        = this.store$.select(selectIsMobile)
  selectEngineOptions    = this.store$.select(selectEngineOptions)

  CanAccommodateOccupancy = CanAccommodateOccupancy

  constructor(){}

  dateRangeFocusChanged(event: boolean){
    this.store$.dispatch(SearchPanelVisibility({open: event}));
  }

  resend(prop: Proposition, dates: DatesAndAccupancy | null){
    if(dates){
      const range = new TuiDayRange( this.asTuiDay(prop.startDate), this.asTuiDay(prop.endDate))
      const datesAndAccupancy = {...dates, range}
      this.store$.dispatch(DatesAndAccupancySubmitted({datesAndAccupancy}))
    }
  }

  asTuiDay(date: string){
    const [year, month, day] = date.split('-')
    return new TuiDay( parseInt(year), parseInt(month)-1, parseInt(day) )
  }

  close(){
    this.store$.dispatch(MobileSearchVisibility({visible: false}));
  }

  closeSearchPanel(){
    this.dateRangeFocusChanged(false)
  }

  getImage(code_room: number){
    return this.store$.select(selectMainImage({code_room}))
  }

  minimize(){
    this.store$.dispatch(Minimize({force: true}));
  }

  getRoomName(roomId: number){
    return this.store$.select(selectRoomNameTranslation({roomId}))
  }

  getAnnulationShortTranslation(annulation: Annulation, fromDate: TuiDay): {codemot: string, params: any}{
    const {traduction} = this.bookingPolicy.getAnnulation(annulation, fromDate)[0];
    const partial = annulation.detail.length == 1 && annulation.detail[0].from == 0 && annulation.detail[0].to == -1;
    
    switch (true) {
      case [BookingPolicyService._NoRemborsableNoDetected, BookingPolicyService._NoRemborsable].includes(annulation.type):
        return {codemot: 'nonrembourssable', params: {}}
        break;
      case annulation.type == BookingPolicyService._FreeCancelation:
        return {codemot: 'annulationgratuite', params: {}}
        break;
      case annulation.type == BookingPolicyService._Flexible && partial == false:
        return {codemot: traduction.codemot, params: traduction.params}
        break;
      case annulation.type == BookingPolicyService._Flexible && partial == true:
        return {codemot: 'partiallyrefundable', params: {}}
        break;
      default:
        return {codemot: '', params: {}}
    }
  }
}
